<div class="workspace-tab-panel w-100">
  <header class="workspace-section-head mb-4 text-start">
    <h1 class="mb-1">ComplyOn</h1>
    <p class="mb-0">Automated identity, location, legitimacy, and credit verification.</p>
  </header>

  <div class="workspace-card-grid w-100">
    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-mint d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa fa-user-check gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Identity & Location Verification</h2>
          <p class="mb-0">Individual Checks</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Verify identity and location during onboarding by connecting in real time to trusted credit bureaus and authoritative sources.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('verification')">
        Verify Identity <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-sky d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa fa-building gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Company Legitimacy Check</h2>
          <p class="mb-0">Entity Validation</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Validate company legitimacy and legal status instantly using integrated bureau data and trusted business records.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('verification')">
        Validate Company <span aria-hidden="true">&rarr;</span>
      </button>
    </article>

    <article class="workspace-app-card d-flex flex-column align-items-stretch bg-white border shadow-sm text-start">
      <div class="workspace-card-top d-flex align-items-center min-w-0">
        <div class="workspace-platform-icon tone-rose d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <i class="fa fa-chart-line gradient-text" aria-hidden="true"></i>
        </div>
        <div class="workspace-card-title min-w-0 text-start">
          <h2 class="mb-1">Credit Standing Assessment</h2>
          <p class="mb-0">Risk & Credit Review</p>
        </div>
      </div>

      <p class="workspace-card-description mb-0 text-start">
        Assess the credit standing of individuals or companies by securely sending captured data to integrated bureaus and returning trusted results.
      </p>

      <button class="btn upload-button workspace-card-cta d-inline-flex align-items-center justify-content-center w-100" type="button" @click="launch_workspace('verification')">
        Assess Credit <span aria-hidden="true">&rarr;</span>
      </button>
    </article>
  </div>
</div>
